import EquipmentMaster from './EquipmentMaster';

const Equipment = () => <EquipmentMaster />;

export default Equipment;
